import { useMsisdnContext } from "./../context/MsisdnContext";
import { useNavigate, useLocation } from "react-router-dom";
import menuHamburger from "./../assets/images/menu.svg";
import logoYas from "./../assets/images/logoYAS.svg";
import search from "./../assets/images/search.svg";

function Header({ hideMsisdn, hideAccount }) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { msisdn, msisdnBalance } = useMsisdnContext();

  const home = () => {
    navigate("/");
  };

  return (
    <>
      <div
        className={`relative top-[0px] left-[0px] w-[100%] [background:#00377D] ${
          hideMsisdn ? " h-[125px]" : hideAccount ? " h-[140px]" : "h-[125px]"
        }`}
      >
        <img
          className={`relative w-[100%] top-[10px] left-[0px] right-[0px] max-w-full max-h-full ${
            hideMsisdn ? "h-[40%]" : "h-[35%]"
          }`}
          alt=""
          src={logoYas}
        />
        <img
          className="absolute top-[30px] left-[28px] w-[19px] h-[17px] z-5 object-contain cursor-pointer "
          alt=""
          src={menuHamburger}
          onClick={() => home()}
        />
        <img
          className="absolute top-[30px] right-[28px] w-[19px] h-[17px] z-5 object-contain cursor-pointer"
          alt=""
          src={search}
        />
        {hideMsisdn ? null : (
          <div className="absolute top-[70px] left-[calc(50%_-_155.5px)] w-[311px] h-[21px] text-lg">
            <div className="absolute top-[-1px] left-[126px] tracking-[0.06em] uppercase font-black">
              {state?.msisdn ?? ''}
            </div>
            <div className="absolute top-[-3px] left-[40px] flex items-center w-[232px] h-6">
              Bonjour,
            </div>
            <img
              className="absolute top-[21px] left-[279px] rounded-lg w-8 h-8 overflow-hidden hidden"
              alt=""
              src="/plus.svg"
            />
            {
              hideAccount ? null : (
                <div className="absolute top-[30px] left-[calc(50%_-_118.5px)] text-sm text-white">
                  <span>{`Votre crédit actuel est de : `}</span>
                  <span className="font-semibold"> {msisdnBalance} Ar</span>
                </div>
              )
            }
          </div>
        )}
      </div>
    </>
  );
}

export default Header;
